<template>
    <component :is="isMyLibrary ? 'div' : 'router-link'"
        :to="$store.state.user.role.name === 'Authenticated' ? ('/' + (item.asset_object_id ? item.asset_object_id : item._id)) : ('/' + (item.asset_object_id ? item.asset_object_id : item._id) + '/edit')"
    >
        <vx-card :class="assetClassName">
            <slot/>
            <div slot="no-body" class="card-img-block">
                <HoverThumb
                    imgClassName="responsive card-img-top"
                    :asset="item"
                    :main="item.thumbnail"
                    :list="item.thumbnails"/>
                <vs-chip
                    :color="['video', 'animation'].indexOf(item.asset_type) !== -1 ? 'danger' : ['image', 'illustration'].indexOf(item.asset_type) !== -1 ? 'success' : 'primary'"
                    class="item-category">{{ getTypeName(item) }}
                </vs-chip>
                <vs-chip color="primary" class="item-type" v-if="item.variants && item.variants.length && item.variants.length > 1">{{ item.variants.length }}</vs-chip>
            </div>
            <h5 class="mb-2">{{ item.title }}</h5>
            <p class="text-grey asset-desc">{{ item.description }}</p>
        </vx-card>
    </component>
</template>

<script>
    import HoverThumb from "../components/HoverThumb";

    export default {
        components: {
            HoverThumb,
        },
        props: {
          item: {type: Object},
          isMyLibrary: {type: Boolean, default: false},
          showImages: {type: Boolean, default: true}
        },
        data() {
            return {}
        },
        computed: {
            assetClassName() {
                let item = this.item;
                let classNames = [];
                classNames.push('type-' + (item.asset_type || "").replace(' ', ''))
                if (!item.asset_object_id && (!item.variants || !item.variants.length)) {
                    classNames.push("is-empty");
                }
                // if (!item.thumbnail && item.variants && item.variants.length && item.variants.filter(v=> v.ready_links && v.ready_links.length).length) {
                //     classNames.push("is-pending");
                // }
                return classNames.join(" ")
            }
        },
        mounted() {},
        methods: {
            getTypeName(item) {
                if (!item.asset_type) return "";
                let type = this.$store.state.assetTypes[item.asset_type] || "";
                if (item.variants_data && item.asset_type === '3D' && item.variants_data.is_animated) {
                  type = 'Animated ' + type;
                }
                return type;
            },
        },
    }
</script>
